import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

// Paper flight-folio scans: photo → S3 → background Claude extraction.
// Extraction takes tens of seconds, so create returns immediately and the
// drawer polls getById while the scan is `processing`.

export function useFlightFolioScanCreate() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.flightFolioScan.create.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.flightFolioScan.key() })
      },
    })
  )
}

export function useFlightFolioScanGetById(id?: string) {
  const orpc = useOrpcTanstackQueryUtils()

  return useQuery({
    ...orpc.flightFolioScan.getById.queryOptions({ input: { id: id! } }),
    enabled: !!id,
    refetchInterval: (query) => (query.state.data?.status === 'processing' ? 2000 : false),
  })
}

// Scan list for one aircraft (admin or pilot).
export function useFlightFolioScanGetByAircraft(aircraftId?: string, opts?: { enabled?: boolean }) {
  const orpc = useOrpcTanstackQueryUtils()

  return useQuery({
    ...orpc.flightFolioScan.getByAircraft.queryOptions({ input: { aircraftId: aircraftId! } }),
    enabled: !!aircraftId && (opts?.enabled ?? true),
  })
}

export function useFlightFolioScanRetry() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.flightFolioScan.retryExtraction.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.flightFolioScan.key() })
      },
    })
  )
}

export function useFlightFolioScanDelete() {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.flightFolioScan.delete.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: orpc.flightFolioScan.key() })
      },
    })
  )
}
